import { __extends } from "tslib";
import { GetPersonTrackingRequest, GetPersonTrackingResponse } from "../models/index";
import { deserializeAws_json1_1GetPersonTrackingCommand, serializeAws_json1_1GetPersonTrackingCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetPersonTrackingCommand = /** @class */ (function (_super) {
    __extends(GetPersonTrackingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetPersonTrackingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetPersonTrackingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetPersonTrackingRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetPersonTrackingResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPersonTrackingCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetPersonTrackingCommand(input, context);
    };
    GetPersonTrackingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetPersonTrackingCommand(output, context);
    };
    return GetPersonTrackingCommand;
}($Command));
export { GetPersonTrackingCommand };
//# sourceMappingURL=GetPersonTrackingCommand.js.map